import { MoonLoader } from "react-spinners";

const LoadingSpinner = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <MoonLoader />
    </div>
  );
};

export default LoadingSpinner;
